import CartItem from "./CartItem";
import Modal from "../Layout/Modal";
import classes from "./CartItem.module.css";
import { CartContext } from "../../CartContext";
import { Fragment, useContext, useState } from "react";
import CartForm from "./CartForm";
import { useNavigate } from "react-router-dom";
import { BiErrorCircle } from "react-icons/bi";
import { AiFillCheckSquare } from "react-icons/ai";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

const Cart = (props) => {
  const navigate = useNavigate();
  const [setForm, setShowForm] = useState(false);
  const cart = useContext(CartContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [didSubmit, setDidSubmit] = useState(false);
  const [error, setError] = useState(false);

  const productCount = cart.items.reduce((acc, item) => acc + item.quantity, 0);

  const showFormHandler = () => {
    setShowForm(true);
  };

  const postCart = () => {
    setIsSubmitting(true);
    fetch("https://dc-luxury-default-rtdb.firebaseio.com/order.json", {
      method: "POST",
      body: JSON.stringify({
        id: cart.token,
        orderedItems: cart.items,
      }),
    }).then((res) => {
      console.log(res);
      if (res.ok) {
        setDidSubmit(true);
        setIsSubmitting(false);
        navigate("/payment", { replace: true });
        // props.hideCart();
      } else {
        setError(true);
        setIsSubmitting(false);
        setDidSubmit(false);
      }
    });
  };

  const initialModalContent = (
    <Fragment>
      <div className={classes.cartContainer}>
        <h1 className="shopping-cart">Your Shopping Cart</h1>
        <ul className={classes.lister}>
          {productCount > 0 ? (
            <CartItem />
          ) : (
            <h1 className="no-item">There are no items in your cart!</h1>
          )}
        </ul>
        <p className={classes.total}>
          Total: N{cart.getTotalCost().toFixed(2)}
        </p>
        {productCount > 0 ? (
          <div className={classes.action}>
            <button onClick={props.hideCart} className={classes.close}>
              Close
            </button>
            <button onClick={showFormHandler} className={classes.order}>
              Order
            </button>
          </div>
        ) : (
          <div className={classes.action}>
            <button onClick={props.hideCart} className={classes.close}>
              Close
            </button>
          </div>
        )}
        {setForm && (
          <CartForm
            id={props.id}
            isLoading={props.isLoading}
            postCart={postCart}
            hideCart={props.hideCart}
          />
        )}
      </div>
    </Fragment>
  );

  const submittingModalContent = (
    <p className={classes.send}>
      Sending Order{" "}
      <span className={classes.sending}>
        <AiOutlineLoading3Quarters />
      </span>
    </p>
  );
  const submittedModalContent = (
    <Fragment>
      <p className={classes.suc}>
        Successfully submitted order, Proceed to payment
        <span className={classes.success}>
          <AiFillCheckSquare />
        </span>
      </p>
      <div className={classes.action}>
        <button onClick={props.hideCart} className={classes.close}>
          Continue
        </button>
      </div>
    </Fragment>
  );
  const errorModalContent = (
    <Fragment>
      <p className={classes.err}>
        Error submitting order, Try again
        <span className={classes.error}>
          <BiErrorCircle />
        </span>
      </p>

      <div className={classes.action}>
        <button onClick={props.hideCart} className={classes.close}>
          Close
        </button>
      </div>
    </Fragment>
  );

  return (
    <Modal hideCart={props.hideCart}>
      {!isSubmitting && !didSubmit && !error && initialModalContent}
      {isSubmitting && !didSubmit && !error && submittingModalContent}
      {!isSubmitting && didSubmit && !error && submittedModalContent}
      {error && !didSubmit && errorModalContent}
    </Modal>
  );
};

export default Cart;
